import React, { useState, useEffect } from "react";

const WHATSAPP_HREF =
  "https://wa.me/916302568325?text=Hi%2C%20I%27d%20like%20to%20enquire%20about%20your%20services.";
const LINKEDIN_HREF = "https://www.linkedin.com/in/ca-roopesh-kumar/";

const WhatsAppIcon = ({ size = 22 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.966-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

const LinkedInIcon = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

export default function FloatingSocial() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      data-testid="floating-social"
      aria-label="Social contact options"
      className={`fixed right-4 md:right-6 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-3 transition-all duration-500 ${
        mounted ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4"
      }`}
    >
      <a
        href={WHATSAPP_HREF}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        data-testid="floating-whatsapp"
        className="group relative flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-[#25D366] text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-x-1"
      >
        <WhatsAppIcon size={22} />
        <span className="pointer-events-none absolute right-full mr-3 px-3 py-2 bg-[#1A2F24] text-[#FDFBF7] text-[11px] tracking-[0.14em] uppercase whitespace-nowrap opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
          Chat on WhatsApp
        </span>
        <span
          aria-hidden="true"
          className="absolute inset-0 border border-white/40 scale-100 group-hover:scale-125 opacity-0 group-hover:opacity-100 transition-all duration-500"
        />
      </a>

      <a
        href={LINKEDIN_HREF}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Connect on LinkedIn"
        data-testid="floating-linkedin"
        className="group relative flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-[#0A66C2] text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-x-1"
      >
        <LinkedInIcon size={20} />
        <span className="pointer-events-none absolute right-full mr-3 px-3 py-2 bg-[#1A2F24] text-[#FDFBF7] text-[11px] tracking-[0.14em] uppercase whitespace-nowrap opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
          Connect on LinkedIn
        </span>
      </a>
    </div>
  );
}
